import { Component, OnInit, Injector, Input } from '@angular/core';
import { isEmpty } from 'lodash';
import { BaseComponent } from '../../base.component';

@Component({
	selector: 'WellCarrier',
	template: `
		<div [ngClass]="{ 'covmod-uuds': isCovModFlagOn, uuds: !isCovModFlagOn }">
			<div class="logo">
				<img [src]="control.attributes.imageUrl" alt="" />
			</div>

			<div class="content">
				<p>
					<CustomHtml [content]="control.attributes.content" [control]="control"></CustomHtml>
				</p>
			</div>

			<div class="link">
				<div *ngIf="control.disabled">
					{{ getTitle() }}
				</div>

				<a *ngIf="!control.disabled" class="btn" (click)="goToBridge()" href="{{ getUrl() }}" target="_blank">
					{{ getTitle() }}
				</a>
			</div>
		</div>
	`,
	styleUrls: ['./well-carrier.component.scss'],
})
export class WellCarrierComponent extends BaseComponent implements OnInit {
	isCovModFlagOn: boolean = false;

	constructor(injector: Injector) {
		super(injector);
	}

	async ngOnInit() {
		this.layoutService.globalAttributes.subscribe((data) => {
			this.isCovModFlagOn = data['covModFlag'];
		});

		if (this.isCovModFlagOn) {
			const elem = this.elementRef.nativeElement.parentElement.parentElement.parentElement;
			this.Renderer.setStyle(elem, 'margin-bottom', '30px');
		}
	}

	goToBridge() {
		if (!isEmpty(this.control.attributes.link)) {
			this.actionService.ajaxAction(this.control.attributes.link.ajaxInfo, this.context);
		}
	}

	getUrl() {
		if (!isEmpty(this.control.attributes.link)) {
			return this.control.attributes.link.attributes.url;
		}
	}

	getTitle() {
		if (!isEmpty(this.control.attributes.link)) {
			return this.control.attributes.link.attributes.title;
		}
	}
}
